import ExitIcon from '@/shared/assets/icons/exitIcon.svg?react'
import UserIcon from '@/shared/assets/icons/user.svg?react'
import { BaseButton } from '@/shared/components'

type UserActionsProps = {
  teamName: string
  onProfileClick: () => void
  onLogout: () => void
}

export const UserActions = ({ teamName, onProfileClick, onLogout }: UserActionsProps) => {
  return (
    <div className="flex flex-col gap-y-3 mt-3 pt-3 pb-3 border-t">
      <span className="px-4 text-main-black dark:text-white">
        <span className="text-text-secondary">{teamName}</span>
      </span>
      <BaseButton
        variant="transparent"
        padding="empty"
        className="disabled:opacity-50 px-4 text-primary hover:text-primary-hover dark:hover:text-primary-dark-hover dark:text-primary-dark"
        onClick={onProfileClick}
      >
        <UserIcon width={24} height={24} />
        Перейти в профиль
      </BaseButton>
      <BaseButton
        variant="transparent"
        padding="empty"
        className="disabled:opacity-50 px-4 text-error/80 hover:text-error"
        onClick={onLogout}
      >
        <ExitIcon width={24} height={24} />
        Выйти из аккаунта
      </BaseButton>
    </div>
  )
}
